export const SWF_FORM_PREFIX = 'swf_form_'